"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Faq = void 0;
class Faq {
}
exports.Faq = Faq;
//# sourceMappingURL=faq.js.map